import { EmptyContent } from '@ztechapps/webui.util'
import React from 'react'
export const EmptyTemplate = () => {
  return (
    <div className="my-4">
      <EmptyContent message="No templates available." icon="file" />
    </div>
  )
}
